/**
 * Dashboard api for the transactions page
 */

import Dashboard from "./dashboard";

export default class TransactionsAPI extends Dashboard {
  constructor() {
    super();
  }

  encodeDataToURL = (params) => {
    let urlVals = Object.keys(params)
      .map((value) => `${value}=${encodeURIComponent(params[value])}`)
      .join("&");
    return urlVals;
  };

  /**
   * Normalize amount for mode B: strip $, commas, trailing zeros / decimal point.
   * e.g. "10.00" → "10", "10.50" → "10.5"
   */
  normalizeAmount(raw) {
    if (raw === null || raw === undefined || raw === "") return null;
    let s = String(raw).trim().replace(/\$/g, "").replace(/,/g, "").replace(/\s/g, "");
    if (!s) return null;
    if (!/^-?\d+(\.\d+)?$/.test(s)) return s;
    // Strip trailing zeros after decimal, then trailing dot
    if (s.includes(".")) {
      s = s.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "").replace(/\.$/, "");
    }
    return s;
  }

  getTransactions(context) {
    console.log(context);
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");

    let params = {};
    if (context.eventId) params.eventId = context.eventId;
    if (context.filterMode) params.filterMode = context.filterMode;

    if (context.filterMode === "a") {
      if (context.searchStartTime && context.searchStartTime !== "notSet") {
        params.startTime = context.searchStartTime;
      }
      if (context.searchEndTime && context.searchEndTime !== "notSet") {
        params.endTime = context.searchEndTime;
      }
      if (context.searchStallholders) {
        params.stallholders = Array.isArray(context.searchStallholders)
          ? context.searchStallholders[0]
          : context.searchStallholders;
      }
      if (context.searchStalls) {
        params.stalls = Array.isArray(context.searchStalls)
          ? context.searchStalls[0]
          : context.searchStalls;
      }
      if (context.searchTerminals) {
        params.terminals = Array.isArray(context.searchTerminals)
          ? context.searchTerminals[0]
          : context.searchTerminals;
      }
    } else if (context.filterMode === "b") {
      if (context.deviceId) params.deviceId = context.deviceId;
      if (context.stan) params.stan = context.stan;
      const amount = this.normalizeAmount(context.totalAmount);
      if (amount !== null) params.totalAmount = amount;
    } else if (context.filterMode === "c") {
      if (context.transactionId) params.transactionId = context.transactionId;
    }

    if (context.limit != null) params.limit = context.limit;
    if (context.exclusiveStartKey) {
      params.exclusiveStartKey = context.exclusiveStartKey;
    }

    let newParams = this.encodeDataToURL(params);

    return this.api
      .get(
        "/components/transactions?user=" +
          accessUser +
          "&accessToken=" +
          accessToken +
          "&" +
          newParams
      )
      .then((response) => {
        return response.data;
      });
  }

  getRawTransaction(context) {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");
    const params = {
      eventId: context.eventId,
      stallholderId: context.stallholderId,
      transactionId: context.transactionId,
      raw: "true",
    };
    const newParams = this.encodeDataToURL(params);
    return this.api
      .get(
        "/components/transactions?user=" +
          accessUser +
          "&accessToken=" +
          accessToken +
          "&" +
          newParams
      )
      .then((response) => response.data);
  }

  /** Receipt-safe DTO for Tax Invoice PDF (any event-authorised user). */
  getReceiptTransaction(context) {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");
    const params = {
      eventId: context.eventId,
      stallholderId: context.stallholderId,
      transactionId: context.transactionId,
      receipt: "true",
    };
    const newParams = this.encodeDataToURL(params);
    return this.api
      .get(
        "/components/transactions?user=" +
          accessUser +
          "&accessToken=" +
          accessToken +
          "&" +
          newParams
      )
      .then((response) => response.data);
  }

  /** Start async full CSV export — returns { jobId, status }. */
  startTransactionsExport(payload) {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");
    return this.api
      .post(
        "/components/transactions/export?user=" +
          accessUser +
          "&accessToken=" +
          accessToken,
        payload
      )
      .then((response) => response.data);
  }

  /** Poll async CSV export job — returns { status, downloadUrl?, error? }. */
  getTransactionsExportStatus(jobId) {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");
    return this.api
      .get(
        "/components/transactions/export?user=" +
          accessUser +
          "&accessToken=" +
          accessToken +
          "&jobId=" +
          encodeURIComponent(jobId)
      )
      .then((response) => response.data);
  }

  /** Request cancel of an in-flight CSV export job. */
  cancelTransactionsExport(jobId) {
    let accessToken = localStorage.getItem("accessToken");
    let accessUser = localStorage.getItem("accessUser");
    return this.api
      .post(
        "/components/transactions/export?user=" +
          accessUser +
          "&accessToken=" +
          accessToken,
        { action: "cancel", jobId }
      )
      .then((response) => response.data);
  }
}
